import { useFormContext } from "react-hook-form";

import {
  resolveCompleteness,
  resolveStepStatus,
  StepKeyValue,
  StepStatus,
  STEPS,
  visibleStepKeys,
} from "./helper";

const ALL_FIELDS = Array.from(
  new Set(Object.values(STEPS).flatMap((definition) => definition.fields))
);

export function useStepStatus(key: StepKeyValue): StepStatus {
  const form = useFormContext();
  const watched: any[] =
    (form?.watch(["orderType", ...ALL_FIELDS]) as any[]) || [];

  const values: Record<string, any> = {};
  ["orderType", ...ALL_FIELDS].forEach((field, index) => {
    values[field] = watched[index];
  });

  const keys = visibleStepKeys(values.orderType);
  const index = keys.indexOf(key);

  if (!form || index < 0) {
    return "upcoming";
  }

  return resolveStepStatus(index + 1, resolveCompleteness(keys, values));
}
